import colors from "../../Theme/base/colors";
import pxToRem from "../../Theme/functions/pxToRem";

const { border, background, text } = colors;

export default {
  small: {
    height: pxToRem(28),
    alignitem: "center",
    fontSize: pxToRem(12),
    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
    padding: "6px 12px !important",
  },
  medium: {
    height: pxToRem(36),
    alignitem: "center",
    fontSize: pxToRem(14),
    padding: "10px 16px !important",
    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },
  large: {
    height: pxToRem(40),
    alignitem: "center",
    padding: "12px 24px !important",
    fontSize: pxToRem(14),
    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },
  fullWidth: {
    minHeight: pxToRem(36),
    width: "100%",
    padding: "12px 24px 12px 24px",
    fontSize: pxToRem(16),
    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },
  primary: {
    backgroundColor: background.default,
    borderColor: border.medium,
    color: text.tertiary,
    "&:hover": {
      backgroundColor: background.default,
      color: text.labelBrand,
      border: `1.5px solid ${border.brand}`,
    },
  },
  secondary: {
    backgroundColor: background.default,
    borderColor: border.medium,
    color: text.labelBrand,
    "&:hover": {
      backgroundColor: background.default,
      border: `1.5px solid ${border.brand}`,
    },
  },
};
